export const useOverflow = (el?: HTMLElement | Element) => {
  const { scrollWidth = 0, clientWidth = 0 } = el || {};
  return {
    isOverflowX: scrollWidth > clientWidth,
  };
};
